function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v512h512v-512zm482 482h-452v-452h452zm0 0",
  "data-original": "#000000",
  className: "active-path",
  fill: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m166 181h-90v255h90zm-30 225h-30v-195h30zm0 0",
  "data-original": "#000000",
  className: "active-path",
  fill: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m121 166c24.8125 0 45-20.1875 45-45s-20.1875-45-45-45-45 20.1875-45 45 20.1875 45 45 45zm0-60c8.269531 0 15 6.730469 15 15s-6.730469 15-15 15-15-6.730469-15-15 6.730469-15 15-15zm0 0",
  "data-original": "#000000",
  className: "active-path",
  fill: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m286 301c0-16.542969 13.457031-30 30-30s30 13.457031 30 30v135h90v-142.5c0-62.03125-50.46875-112.5-112.5-112.5-12.871094 0-25.53125 2.1875-37.5 6.421875v-6.421875h-90v255h90zm-30 0v105h-30v-195h30v27.769531l23.089844-14.789062c13.257812-8.492188 28.617187-12.980469 44.410156-12.980469 45.492188 0 82.5 37.007812 82.5 82.5v112.5h-30v-105c0-33.085938-26.914062-60-60-60s-60 26.914062-60 60zm0 0",
  "data-original": "#000000",
  className: "active-path",
  fill: "#000000"
}));

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    viewBox: "0 0 512 512",
    width: "512px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.02a4b6d1.svg";
export { ForwardRef as ReactComponent };